export const briefItems = [
  {
    id: 'b-01',
    date: '09-10',
    time: '00:42',
    title: '某选秀出身男歌手被曝在同一时段与多人保持联系，工作室凌晨发长文但未否认核心时间线',
    tags: ['塌房', '感情线', '进行中'],
    status: '进行中',
    heat: 12840,
    result: '暂无最终结果',
  },
  {
    id: 'b-02',
    date: '09-09',
    time: '23:58',
    title: '热播剧男二被指在拍摄期频繁缺席围读，剧方沉默三天后放出通告单',
    tags: ['耍大牌', '合作纠纷', '已实锤'],
    status: '已实锤',
    heat: 9640,
    result: '剧组已调整后续排期',
  },
  {
    id: 'b-03',
    date: '09-09',
    time: '22:31',
    title: '综艺常驻女主持被质疑剪辑偏向，节目组放出未播片段，舆论当天反转',
    tags: ['争议', '言论失当', '出现反转'],
    status: '出现反转',
    heat: 8730,
    result: '节目组补充说明，风向缓和',
  },
  {
    id: 'b-04',
    date: '09-09',
    time: '21:05',
    title: '独立音乐人被指整段旋律与旧作高度重合，对方方仍未回应',
    tags: ['抄袭', '数据造假', '冷处理'],
    status: '冷处理',
    heat: 6420,
    result: '双方均未再发声',
  },
  {
    id: 'b-05',
    date: '09-09',
    time: '19:47',
    title: '新晋品牌被曝代言物料未经沟通更换，合作方深夜删除全部联动内容',
    tags: ['违规代言', '合作纠纷', '进行中'],
    status: '进行中',
    heat: 5990,
    result: '暂无最终结果',
  },
  {
    id: 'b-06',
    date: '09-09',
    time: '18:20',
    title: '导演选角风波：原定演员临期退出，制片方首次公开试镜记录',
    tags: ['选角风波', '争议', '已出结果'],
    status: '已出结果',
    heat: 5410,
    result: '新演员已进组，事件收尾',
  },
  {
    id: 'b-07',
    date: '09-08',
    time: '23:12',
    title: '某女演员工作室被指拖欠合作团队款项，双方各执一词，已进入协商',
    tags: ['财务纠纷', '赔偿', '进行中'],
    status: '进行中',
    heat: 4870,
    result: '已进入协商阶段',
  },
  {
    id: 'b-08',
    date: '09-08',
    time: '20:36',
    title: '粉丝数据站被曝集中刷榜，平台清空异常数据后排名回落',
    tags: ['数据造假', '翻车', '已出结果'],
    status: '已出结果',
    heat: 4230,
    result: '平台清除异常数据',
  },
  {
    id: 'b-09',
    date: '09-08',
    time: '16:09',
    title: '某演员早期采访片段被翻出，涉及言论失当，本人当日作出说明',
    tags: ['言论失当', '丑闻', '已澄清'],
    status: '已澄清',
    heat: 3810,
    result: '本人致歉，事件基本收束',
  },
  {
    id: 'b-10',
    date: '09-07',
    time: '22:50',
    title: '某乐队巡演临时取消未提前告知，主办方次日发布退票方案',
    tags: ['翻车', '合作纠纷', '已出结果'],
    status: '已出结果',
    heat: 3260,
    result: '已公布退票与补偿方案',
  },
];